import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import s from './ReturnInstructions.module.css';
import { Language } from '../Language';

const propTypes = {
  title: PropTypes.string,
  address: PropTypes.shape({
    to_name: PropTypes.string,
    to_company: PropTypes.string,
    to_address1: PropTypes.string,
    to_city: PropTypes.string,
    to_state: PropTypes.string,
    to_zip5: PropTypes.string,
  }),
};

const defaultProps = {
  title: '',
  address: null,
};

const WarehouseAddress = ({ address }) => {
  if (isEmpty(address)) return null;

  const {
    to_name: name = '',
    to_company: company = '',
    to_address1: address1 = '',
    to_city: city = '',
    to_state: state = '',
    to_zip5: zip = '',
  } = address;

  return (
    <div className={s.warehouse_address_wrapper}>
      <Language
        tagName="h5"
        langKey="returns.step_4.warehouse_address"
        className={s.warehouse_address_title}
      />
      <section className={s.warehouse_address_item}>
        <span className={s.warehouse_address_item}>{name}</span>
        <span className={s.warehouse_address_item}>{company}</span>
        <span className={s.warehouse_address_item}>{address1}</span>
        <span className={s.warehouse_address_item}>{`${city}, ${state} ${zip}`}</span>
      </section>
    </div>
  );
};

WarehouseAddress.propTypes = propTypes;
WarehouseAddress.defaultProps = defaultProps;
export default WarehouseAddress;
